import { render, staticRenderFns } from "./ModificarDescuentos.vue?vue&type=template&id=d3369078&scoped=true&"
import script from "./ModificarDescuentos.vue?vue&type=script&lang=js&"
export * from "./ModificarDescuentos.vue?vue&type=script&lang=js&"
import style0 from "./ModificarDescuentos.vue?vue&type=style&index=0&id=d3369078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3369078",
  null
  
)

export default component.exports